import type { FC } from "react";
import { useEffect, useState } from "react";

import { Presets } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { IRTCurrentCampaignData } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import { useKeywordsQuickFiltersQuery } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/hooks";
import type { RTRawParams } from "app/pages/digital-marketing/keywords-campaigns/reports/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

import type { EKeywordsReportTableFilters } from "./KeywordsReportTableFiltersConsts";

interface IKeywordsReportKeywordsTablePresets {
    currentCampaignConfiguration: IRTCurrentCampaignData;
    stateParams: RTRawParams;
    clickablePresets: boolean;
    handleCardSelected?: (id: EKeywordsReportTableFilters) => void;
    isPendingUpdate?: boolean;
}
export const KeywordsReportKeywordsTablePresets: FC<IKeywordsReportKeywordsTablePresets> = (props) => {
    const { currentCampaignConfiguration, stateParams, handleCardSelected, isPendingUpdate = false } = props;
    const { useCaseFilter } = stateParams;
    const [selectedCardID, setSelectedCardID] = useState<EKeywordsReportTableFilters>(
        useCaseFilter as EKeywordsReportTableFilters,
    );
    const { data: filtersData, isLoading: isLoadingData } = useKeywordsQuickFiltersQuery({
        currentCampaignConfiguration,
    });

    const isLoading = isLoadingData || isPendingUpdate;

    const handleSelect = (id: EKeywordsReportTableFilters) => {
        allTrackers.dispatchTrackEvent("Filter Table", "click", `Presets Clicked/${id}`);
        if (handleCardSelected) {
            handleCardSelected(id);
        } else {
            if (id === useCaseFilter) {
                setSelectedCardID(null);
            } else {
                setSelectedCardID(id);
            }
        }
    };

    useEffect(() => {
        proNavigator.updateParams<RTRawParams>({ useCaseFilter: selectedCardID });
    }, [selectedCardID]);

    return (
        <Presets
            presetsData={filtersData}
            isLoading={isLoading}
            selectedPresetId={useCaseFilter}
            onSelectOrRemove={handleSelect}
            dataLabel={translate("rankTracker.keywords.presets.keywords")}
            title={translate("RT.Trend.presets.title")}
            enableCarousel={false}
        />
    );
};
